export function getFiscalYearMonthAbbreviations(fiscalYearStartMonth) {
  let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  if (fiscalYearStartMonth <= 1 || fiscalYearStartMonth > 12) {
      return months;
  }

  let fiscalMonths = [];
  for (let i = fiscalYearStartMonth - 1; i < 12; i++) {
      fiscalMonths.push(months[i]);
  }
  for (let i = 0; i < fiscalYearStartMonth - 1; i++) {
      fiscalMonths.push(months[i]);
  } 
  return fiscalMonths;
}

export function getFiscalYearMonths(fiscalYearStartMonth) {
  let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  if (fiscalYearStartMonth <= 1 || fiscalYearStartMonth > 12) {
      return months;
  }
  
  let fiscalMonths = [];
  for (let i = fiscalYearStartMonth - 1; i < 12; i++) {
      fiscalMonths.push(months[i]);
  }
  for (let i = 0; i < fiscalYearStartMonth - 1; i++) {
      fiscalMonths.push(months[i]);
  } 
  return fiscalMonths;
}

export function getFiscalYearMonthAbbreviationsWithYear(fiscalYearStartMonth, fiscalYear) {
  let months = ['Jan ', 'Feb ', 'Mar ', 'Apr ', 'May ', 'Jun ', 'Jul ', 'Aug ', 'Sep ', 'Oct ', 'Nov ', 'Dec '];
  if (fiscalYearStartMonth <= 1 || fiscalYearStartMonth > 12) {
      return months.map(e => e + fiscalYear);
  }

  let priorFiscalYear = fiscalYear - 1;
  let fiscalMonths = [];
  for (let i = fiscalYearStartMonth - 1; i < 12; i++) {
      fiscalMonths.push(months[i] + priorFiscalYear);
  }
  for (let i = 0; i < fiscalYearStartMonth - 1; i++) {
      fiscalMonths.push(months[i] + fiscalYear);
  } 
  return fiscalMonths;
}

export function getFiscalYearMonthsWithYear(fiscalYearStartMonth, fiscalYear) {
  let months = ['January ', 'February ', 'March ', 'April ', 'May ', 'June ', 'July ', 'August ', 'September ', 'October ', 'November ', 'December '];
  if (fiscalYearStartMonth <= 1 || fiscalYearStartMonth > 12) {
      return months.map(e => e + fiscalYear);
  }
 
  let priorFiscalYear = fiscalYear - 1;
  let fiscalMonths = [];
  for (let i = fiscalYearStartMonth - 1; i < 12; i++) {
      fiscalMonths.push(months[i] + priorFiscalYear);
  }
  for (let i = 0; i < fiscalYearStartMonth - 1; i++) {
      fiscalMonths.push(months[i] + fiscalYear);
  } 
  return fiscalMonths;
}

export function getStartOfFiscalYear(fiscalYearStartMonth, fiscalYear) {
  return new Date(fiscalYear, fiscalYearStartMonth - 1 /* javascript uses an index for month */, 1);
}

export function getEndOfFiscalYear(fiscalYearStartMonth, fiscalYear) {
  return getEndOfPriorFiscalYear(fiscalYearStartMonth, fiscalYear + 1);
}

export function getStartOfPriorFiscalYear(fiscalYearStartMonth, fiscalYear) {
  return getStartOfFiscalYear(fiscalYearStartMonth, fiscalYear - 1);
}

export function getEndOfPriorFiscalYear(fiscalYearStartMonth, fiscalYear) {
  let date = getStartOfFiscalYear(fiscalYearStartMonth, fiscalYear);
  date.setDate(date.getDate() - 1);
  return date;
}